// function bindMouseOverToMegaMenu(item) {

//     const megaMenuBackdrop = document.querySelector(".mega-menu__backdrop");

//     item.addEventListener("mouseover", (e) => {
//       //e.preventDefault();
//       if(item.classList.contains('mega-menu')){

//         item.setAttribute("open", true);
//         megaMenuBackdrop.style.display = 'block';
//         item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {

//           item.setAttribute("open", true);
//           item.querySelector(".mega-menu__content").addEventListener("mouseover", () => {
//             item.setAttribute("open", true);
//           });

//           item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
//             item.removeAttribute("open");
//             megaMenuBackdrop.style.display = 'none';
//           });

//         });

//         item.querySelector(".mega-menu__content").addEventListener("mouseleave", () => {
//           item.removeAttribute("open");
//           megaMenuBackdrop.style.display = 'none';
//         });
//         item.addEventListener("mouseleave", (e) => {
//           //e.preventDefault();
//           item.removeAttribute("open");
//           megaMenuBackdrop.style.display = 'none';
//         });

//         item.querySelector("summary").addEventListener("click", function(e){
//           //e.preventDefault();
//         });

//       }

//       if(item.classList.contains('dropdown-menu')) {
//         item.setAttribute("open", true);
//         item.querySelector(".header__submenu").addEventListener("mouseleave", (e) => {
//           //e.preventDefault();
//           item.removeAttribute("open");
//         });
//         item.addEventListener("mouseleave", (e) => {
//           //e.preventDefault();
//           item.removeAttribute("open");
//         });
//       }
      
//     });

// }

function bindMouseOverToMegaMenu(item) {
  const megaMenuBackdrop = document.querySelector(".mega-menu__backdrop");

  if (item.classList.contains('mega-menu')) {
    const megaMenuContent = item.querySelector(".mega-menu__content");

    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
      megaMenuBackdrop.style.display = 'block';
    });

    megaMenuContent.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    megaMenuContent.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      megaMenuBackdrop.style.display = 'none';
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
      megaMenuBackdrop.style.display = 'none';
    });

    const mainNavLink = item.querySelector("summary a");
    mainNavLink.addEventListener("click", function(){
      const link = mainNavLink.getAttribute('href');
      window.location.href = link;
    });


  } else if (item.classList.contains('dropdown-menu')) {
    const headerSubmenu = item.querySelector(".header__submenu");

    item.addEventListener("mouseover", () => {
      item.setAttribute("open", true);
    });

    headerSubmenu.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });

    item.addEventListener("mouseleave", () => {
      item.removeAttribute("open");
    });
  }
}


function bindClickToMegaMenu(item){

    const megaMenuBackdrop = document.querySelector(".mega-menu__backdrop");

    item.addEventListener("click", function(e){
        //e.preventDefault();
        if(megaMenuBackdrop.style.display === 'none'){
        megaMenuBackdrop.style.display = 'block'
        }else {
        megaMenuBackdrop.style.display = 'none'
        }

    });
}

function isMobileOrTablet() {
    const userAgent = navigator.userAgent;
    const isMobile = /Mobile|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
    const isTablet = /iPad|Tablet|Android/.test(userAgent);

    return isMobile || isTablet;
}

let items = document.querySelector(".header__inline-menu").querySelectorAll("details.mega-menu");

items.forEach(bindMouseOverToMegaMenu);


if(isMobileOrTablet()){
    items.forEach(bindClickToMegaMenu);
}
  
let itemsDropdown = document.querySelector(".header__inline-menu").querySelectorAll("details.dropdown-menu");
itemsDropdown.forEach(bindMouseOverToMegaMenu);